import { FallbackProps } from 'react-error-boundary';
import { isHttpError } from '@ecolytiq/js-data-provider';

import { common } from 'App/translations';

export const HttpErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const handleResetApp = () => resetErrorBoundary();
  const { tryAgain } = common;
  const { message } = error;

  if (!isHttpError(error)) {
    throw error;
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <pre>{message}</pre>
      <button onClick={handleResetApp} type='button'>
        {tryAgain}
      </button>
    </div>
  );
};
